import { render, staticRenderFns } from "./byAirData.vue?vue&type=template&id=cf074142&scoped=true"
import script from "./byAirData.vue?vue&type=script&lang=js"
export * from "./byAirData.vue?vue&type=script&lang=js"
import style0 from "./byAirData.vue?vue&type=style&index=0&id=cf074142&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf074142",
  null
  
)

export default component.exports